<template>
</template>

<script>
  export default {
    name: 'process-responses-filter-panel-additional'
  }
</script>

<style lang="scss" scoped>
</style>
